//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { getStorage } from "@/js/utils";
import { SUCCESS_CODE } from '@/service/httpCode';
import Float from '@/js/float';
import OfflineRepayQuestions from '@/components/Repay/OfflineRepayQuestions';
import OfflineRepaySecondStep from '@/components/Repay/OfflineRepaySecondStep';
import loadFont from "@/js/loadFont";
const firstStep = require('@/assets/Repay/first-step.png');
const firstStepKoo = require('@/assets/Repay/first-step-koo.png');

export default {
    data() {
        return { amount: '', themeType: '', firstStep, firstStepKoo };
    },
    components: {
        OfflineRepayQuestions,
        OfflineRepaySecondStep,
    },
    computed: {},
    methods: {
        remark() {
            this.sensorsRecord('h5_clk', {
                tgt_event_id: 'h5_paycash_offline_button',
                tgt_name: 'h5-paycash-线下还款页-登记按钮',
                url: location.href,
                page: '还款-线下还款页',
            });

            this.showTheLoading(async () => {
                const {
                    orderNum,
                    redPacketCode,
                    multiPeriod,
                    offAmount,
                    vipOpenTag,
                    repayfmCouponAmount,
                    repaydlCouponAmount
                } = this.$route.query;
                const { result, resultMessage } = await this.$http.offlineRepay({
                    orderNum,
                    redEnvelopeCode: redPacketCode,
                    multiPeriod,
                    offAmount: +offAmount,
                    vipOpenTag,
                    repayfmCouponAmount: +repayfmCouponAmount,
                    amount: this.amount,
                    repaydlCouponAmount: +repaydlCouponAmount
                });
                if (result === SUCCESS_CODE || resultMessage == '已登记成功') {
                    // this.$router.push({
                    //   name: 'offlineRepayGuide',
                    //   query: { amount: this.amount },
                    // });
                    this.$vux.toast.text(resultMessage, 'middle');
                    this.$refs.secondStep.activeNames = ['1']; // 展开转账信息
                }
            }, 'isLoading');
        },
    },
    created() {
        loadFont();
        // this.isApp =
        //     window.PPDWebUI &&
        //     window.PPDWebUI.os.inApp &&
        //     ["PPDLendApp", "PPDLoanApp"].includes(window.PPDWebUI.os.channel);
        const {
            amount,
            themeType,
            bizCode,
            offAmount,
            repayfmCouponAmount,
            offRandomAmount, // 接口返回 0 || null url传参会转成 '0'和'null'
            repaydlCouponAmount
        } = this.$route.query;

        // const offBankVo = getStorage("session", "offBankVo");
        this.amount = offAmount ? Float.subtract(amount, offAmount, 2) : amount;
        // 还款费免券
        if (repayfmCouponAmount) {
            this.amount = repayfmCouponAmount
                ? Float.subtract(this.amount, repayfmCouponAmount, 2)
                : this.amount;
        }
        // 随机立减
        if (offRandomAmount) {
            this.amount = offRandomAmount
                ? Float.subtract(this.amount, offRandomAmount, 2)
                : this.amount;
        }
        // 导流优惠券金额
        if (repaydlCouponAmount) {
            this.amount = repaydlCouponAmount
                ? Float.subtract(this.amount, repaydlCouponAmount, 2)
                : this.amount;
        }


        this.themeType = themeType;
        // this.isKoo = bizCode === "105";
        // this.isTars = bizCode === "117";
        this.sensorsRecord('h5_element_imp', {
            tgt_event_id: 'h5_paycash_offline_repay',
            tgt_name: 'h5-paycash-线下还款页',
            url: location.href,
            page: '还款-线下还款页',
            param4: this.amount,
        });
        // 随机立减文案曝光
        if (this.$route.query.offRandomAmount && this.$route.query.offRandomAmount !== 'null' && this.$route.query.offRandomAmount !== '0') {
            this.sensorsRecord('h5_element_imp', {
                tgt_event_id: 'h5_paycash_offline_off_random_amount',
                tgt_name: 'h5-paycash-线下还款页-随机立减文案曝光',
                url: location.href,
                page: '还款-线下还款页',
            });
        }
    },
};
